import { render, staticRenderFns } from "./trainVet.vue?vue&type=template&id=01b31d09&scoped=true&"
import script from "./trainVet.vue?vue&type=script&lang=js&"
export * from "./trainVet.vue?vue&type=script&lang=js&"
import style0 from "./trainVet.vue?vue&type=style&index=0&id=01b31d09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b31d09",
  null
  
)

export default component.exports